<div class="modal fade modal-background" id="mobileNumberVerificationModal" #mobileNumberVerificationModal tabindex="-1" role="dialog" data-bs-backdrop="static" aria-labelledby="modalLabel" aria-hidden="true" (click)="onContainerClicked($event)">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <form class="login-form" id="mobileNumberVerificationForm" [formGroup]="mobileNumberVerificationForm" (ngSubmit)="submitMobileNumberVerificationForm()">
        <div class="modal-header">
          <h2 i18n>Verify Mobile Number</h2>
          <button type="button" class="modal-close-button" (click)="closeModal()" aria-label="Close">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="modal-body">
          <div>
            <p class="mb-3" i18n>Please enter the 6-digit code you received now via SMS.</p>
            <div class="mobile-verification-code-div">
              <input type="number" class="form-control number-input no-validation-error-icon" maxlength="1" id="digit1" #digitOne (keyup)="onPINCodeKeyup($event, digitTwo, undefined)" formControlName="digit1" [ngClass]="{'is-invalid': digit1?.touched && digit1?.invalid}" />
              <input type="number" class="form-control number-input no-validation-error-icon" maxlength="1" id="digit2" #digitTwo (keyup)="onPINCodeKeyup($event, digitThree, digitOne)" formControlName="digit2" [ngClass]="{'is-invalid': digit2?.touched && digit2?.invalid}" />
              <input type="number" class="form-control number-input no-validation-error-icon" maxlength="1" id="digit3" #digitThree (keyup)="onPINCodeKeyup($event, digitFour, digitTwo)" formControlName="digit3" [ngClass]="{'is-invalid': digit3?.touched && digit3?.invalid}" />
              <input type="number" class="form-control number-input no-validation-error-icon" maxlength="1" id="digit4" #digitFour (keyup)="onPINCodeKeyup($event, digitFive, digitThree)" formControlName="digit4" [ngClass]="{'is-invalid': digit4?.touched && digit4?.invalid}" />
              <input type="number" class="form-control number-input no-validation-error-icon" maxlength="1" id="digit5" #digitFive (keyup)="onPINCodeKeyup($event, digitSix, digitFour)" formControlName="digit5" [ngClass]="{'is-invalid': digit5?.touched && digit5?.invalid}" />
              <input type="number" class="form-control number-input no-validation-error-icon" maxlength="1" id="digit6" #digitSix (keyup)="onPINCodeKeyup($event, undefined, digitFive)" formControlName="digit6" [ngClass]="{'is-invalid': digit6?.touched && digit6?.invalid}" />
            </div>
            <p class="mb-3" i18n>You can send another code in <span class="resend-timer">{{ resendTimerSeconds | secondsToMinutesSeconds }}</span></p>
            <div class="resend-button-div">
              <p i18n><b>Didn't receive code?</b></p>
              <button class="resend-button" [disabled]="disableResendVerificationButton" (click)="resendMobileNumberVerificationCode()" i18n><b>Resend</b></button>
            </div>
          </div>
        </div>

        <div class="alert alert-success form-alert" *ngIf="verifyMobileNumberSuccessMessage !== null">{{ verifyMobileNumberSuccessMessage }}</div>

        <!--      <div class="modal-footer">-->
        <!--        <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>-->
        <div class="verify-button-modal-div">
          <button class="btn submit-button button-primary" type="submit" id="verify-number-modal" *ngIf="!loadingAddMobileButton" i18n>Verify Mobile</button>
          <button class="button-primary" type="button" disabled *ngIf="loadingAddMobileButton">
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            <span class="visually-hidden" role="status">Loading...</span>
          </button>
        </div>
        <!--      </div>-->
      </form>
    </div>
  </div>
</div>


<div>
  <div class="form-div">
    <form class="login-form" id="mobileNumberForm" [formGroup]="mobileNumberForm" (ngSubmit)="submitMobileNumberForm()">
      <h2 i18n>Contact Information</h2>
      <label class="mb-1" i18n>Please enter your mobile number</label>
      <div class="mobile-number-div">
        <div class="form-floating mb-3 country-code-div">
          <input type="text" class="form-control" id="floatingInputCountryCode" placeholder="+20" disabled>
          <label for="floatingInputCountryCode">+20</label>
        </div>
        <div class="form-floating mb-3 mobile-number-input-div">
          <input type="number" class="form-control" id="floatingInputMobileNumberDisabled" placeholder="Mobile Number" formControlName="mobileNumber" [ngClass]="{'is-invalid': (mobileNumber?.touched && mobileNumber?.invalid) || mobileNumberErrorMessage !== null}" >
          <label for="floatingInputMobileNumberDisabled" i18n>Mobile Number</label>
          <div class="invalid-feedback" *ngIf="mobileNumber?.touched && mobileNumber?.invalid">
            <div *ngIf="mobileNumber?.hasError('required')" i18n>Mobile number is required.</div>
            <div *ngIf="mobileNumber?.hasError('minlength')" i18n>Mobile number too short.</div>
            <div *ngIf="mobileNumber?.hasError('maxlength')" i18n>Mobile number too long.</div>
            <div *ngIf="mobileNumber?.hasError('pattern')" i18n>Mobile number must be digits only.</div>
          </div>
          <div class="invalid-feedback" *ngIf="mobileNumberErrorMessage !== null">{{ mobileNumberErrorMessage }}</div>
        </div>
      </div>
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchHasWhatsapp" formControlName="hasWhatsapp" [checked]="hasWhatsapp"  [disabled]="mobileNumberVerified">
        <label class="form-check-label" for="flexSwitchHasWhatsapp" i18n>Has Whatsapp</label>
      </div>
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchHasTelegram" formControlName="hasTelegram" [checked]="hasTelegram"  [disabled]="mobileNumberVerified">
        <label class="form-check-label" for="flexSwitchHasTelegram" i18n>Has Telegram</label>
      </div>
<!--      <div class="verify-mobile-button-div">-->
<!--        &lt;!&ndash; Button to trigger modal &ndash;&gt;-->
<!--        <button type="button" class="btn btn-primary button-primary" (click)="openVerifyMobileModal()"  [disabled]="mobileNumberVerified" i18n>Verify Mobile</button>-->
<!--      </div>-->
      <div class="alert alert-success form-alert" *ngIf="mobileNumberVerified" i18n>Thank you. Your number has been verified successfully.</div>
      <div class="alert alert-danger form-alert" *ngIf="!mobileNumberVerified && addMobileNumberErrorMessage !== null">{{ addMobileNumberErrorMessage }}</div>
      <div class="alert alert-danger form-alert" *ngIf="!mobileNumberVerified && signupService.mobileNumberErrorMessage !== null">{{ signupService.mobileNumberErrorMessage }}</div>
    </form>
  </div>

  <div class="form-div">
    <form class="login-form" id="socialMediaLinksForm" [formGroup]="socialMediaLinksForm" (ngSubmit)="submitSocialMediaLinksForm()">
      <h2 i18n>Social Media</h2>
      <div class="mb-3">
        <div class="input-group" [ngClass]="{'is-invalid': (website?.touched && website?.invalid) || signupService.websiteErrorMessage !== null}">
          <span class="input-group-text social-media-link-icon" id="basic-addon12"><i class="bi bi-globe2"></i></span>
          <div class="form-floating">
            <input type="text" class="form-control social-media-link-input" id="floatingInputWebsite" placeholder="Website" formControlName="website">
            <label for="floatingInputWebsite" i18n>Website</label>
          </div>
        </div>
        <div class="invalid-feedback" *ngIf="website?.touched && website?.invalid">
          <div *ngIf="website?.hasError('minlength')" i18n>URL is too short.</div>
          <div *ngIf="website?.hasError('maxlength')" i18n>URL is too long.</div>
          <div *ngIf="website?.hasError('pattern')" i18n>Invalid URL format.</div>
        </div>
        <div class="invalid-feedback" *ngIf="signupService.websiteErrorMessage !== null">{{ signupService.websiteErrorMessage }}</div>
      </div>

      <div class="mb-3">
        <div class="input-group" [ngClass]="{'is-invalid': (instagram?.touched && instagram?.invalid) || signupService.instagramErrorMessage !== null}">
          <span class="input-group-text social-media-link-icon" id="basic-addon13"><i class="bi bi-instagram"></i></span>
          <div class="form-floating">
            <input type="text" class="form-control social-media-link-input" id="floatingInputInstagram" placeholder="Instagram" formControlName="instagram">
            <label for="floatingInputInstagram" i18n>Instagram</label>
          </div>
        </div>
        <div class="invalid-feedback" *ngIf="instagram?.touched && instagram?.invalid">
          <div *ngIf="instagram?.hasError('minlength')" i18n>URL is too short.</div>
          <div *ngIf="instagram?.hasError('maxlength')" i18n>URL is too long.</div>
          <div *ngIf="instagram?.hasError('pattern')" i18n>Invalid URL format.</div>
        </div>
        <div class="invalid-feedback" *ngIf="signupService.instagramErrorMessage !== null">{{ signupService.instagramErrorMessage }}</div>
      </div>

      <div class="mb-3">
        <div class="input-group" [ngClass]="{'is-invalid': (facebook?.touched && facebook?.invalid) || signupService.facebookErrorMessage !== null}">
          <span class="input-group-text social-media-link-icon" id="basic-addon14"><i class="bi bi-facebook"></i></span>
          <div class="form-floating">
            <input type="text" class="form-control social-media-link-input" id="floatingInputFacebook" placeholder="Facebook" formControlName="facebook">
            <label for="floatingInputFacebook" i18n>Facebook</label>
          </div>
        </div>
        <div class="invalid-feedback" *ngIf="facebook?.touched && facebook?.invalid">
          <div *ngIf="facebook?.hasError('minlength')" i18n>URL is too short.</div>
          <div *ngIf="facebook?.hasError('maxlength')" i18n>URL is too long.</div>
          <div *ngIf="facebook?.hasError('pattern')" i18n>Invalid URL format.</div>
        </div>
        <div class="invalid-feedback" *ngIf="signupService.facebookErrorMessage !== null">{{ signupService.facebookErrorMessage }}</div>
      </div>


      <div class="mb-3">
        <div class="input-group" [ngClass]="{'is-invalid': (tiktok?.touched && tiktok?.invalid) || signupService.tiktokErrorMessage !== null}">
          <span class="input-group-text social-media-link-icon" id="basic-addon15"><i class="bi bi-tiktok"></i></span>
          <div class="form-floating">
            <input type="text" class="form-control social-media-link-input" id="floatingInputTikTok" placeholder="TikTok" formControlName="tiktok">
            <label for="floatingInputTikTok" i18n>TikTok</label>
          </div>
        </div>
        <div class="invalid-feedback" *ngIf="tiktok?.touched && tiktok?.invalid">
          <div *ngIf="tiktok?.hasError('minlength')" i18n>URL is too short.</div>
          <div *ngIf="tiktok?.hasError('maxlength')" i18n>URL is too long.</div>
          <div *ngIf="tiktok?.hasError('pattern')" i18n>Invalid URL format.</div>
        </div>
        <div class="invalid-feedback" *ngIf="signupService.tiktokErrorMessage !== null">{{ signupService.tiktokErrorMessage }}</div>
      </div>

      <div class="mb-3">
        <div class="input-group" [ngClass]="{'is-invalid': (youtube?.touched && youtube?.invalid) || signupService.youtubeErrorMessage !== null}">
          <span class="input-group-text social-media-link-icon" id="basic-addon16"><i class="bi bi-youtube"></i></span>
          <div class="form-floating">
            <input type="text" class="form-control social-media-link-input" id="floatingInputYouTube" placeholder="YouTube" formControlName="youtube">
            <label for="floatingInputYouTube" i18n>YouTube</label>
          </div>
        </div>
        <div class="invalid-feedback" *ngIf="youtube?.touched && youtube?.invalid">
          <div *ngIf="youtube?.hasError('minlength')" i18n>URL is too short.</div>
          <div *ngIf="youtube?.hasError('maxlength')" i18n>URL is too long.</div>
          <div *ngIf="youtube?.hasError('pattern')" i18n>Invalid URL format.</div>
        </div>
        <div class="invalid-feedback" *ngIf="signupService.youtubeErrorMessage !== null">{{ signupService.youtubeErrorMessage }}</div>
      </div>

      <div class="mb-3">
        <div class="input-group" [ngClass]="{'is-invalid': (x?.touched && x?.invalid) || signupService.xErrorMessage !== null}">
          <span class="input-group-text social-media-link-icon" id="basic-addon17"><i class="bi bi-twitter-x"></i></span>
          <div class="form-floating">
            <input type="text" class="form-control social-media-link-input" id="floatingInputX" placeholder="X" formControlName="x">
            <label for="floatingInputX" i18n>X</label>
          </div>
        </div>
        <div class="invalid-feedback" *ngIf="x?.touched && x?.invalid">
          <div *ngIf="x?.hasError('minlength')" i18n>URL is too short.</div>
          <div *ngIf="x?.hasError('maxlength')" i18n>URL is too long.</div>
          <div *ngIf="x?.hasError('pattern')" i18n>Invalid URL format.</div>
        </div>
        <div class="invalid-feedback" *ngIf="signupService.xErrorMessage !== null">{{ signupService.xErrorMessage }}</div>
      </div>

      <div class="alert alert-danger form-alert" *ngIf="signupService.contactFormErrorMessage !== null">{{ signupService.contactFormErrorMessage }}</div>
    </form>
  </div>
</div>
